import { Link } from '~/components'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { SiteFooterColumn } from './SiteFooterColumn'
import styles from './SiteFooterHoursColumn.module.scss'
import { SiteFooterHoursColumnProps } from './SiteFooterHoursColumn.types'

export const SiteFooterHoursColumn = ({
  title,
  phoneNumber,
  hours,
  isMobile,
}: SiteFooterHoursColumnProps) => {
  return (
    <SiteFooterColumn
      title={title}
      panelId='site-footer-hours'
      isMobile={isMobile}
      variant='hours'>
      <div className={styles.table}>
        {hours.map((hour, index) => {
          return (
            <div key={index} className={styles.row}>
              <Typography
                tag={TypographyTag.span}
                variant={TypographyVariant.BodyRegular}
                className={styles.day}>
                {hour.label}
              </Typography>
              <Typography
                tag={TypographyTag.span}
                variant={TypographyVariant.BodyRegularMedium}
                className={styles.time}>
                {hour.time}
              </Typography>
            </div>
          )
        })}
      </div>
      <Link
        href={`tel:${phoneNumber.replace(/\s/g, '')}`}
        className={styles.phone}>
        <Typography
          tag={TypographyTag.span}
          variant={TypographyVariant.BodyRegular}
          className={styles.phoneText}>
          {phoneNumber}
        </Typography>
      </Link>
    </SiteFooterColumn>
  )
}
